class i4_Edit_toolbar {
  constructor(element) {
    this.$element = $(element);

    this.selectors = {
      body: 'body'
    };

    this.data = {
      pluginName: 'plugin-name',
      buttons: 'buttons',
      editMode: 'i4-edit-mode'
    };

    this.classNames = {
      container: 'i4-component-edit',
      overlay: 'i4-component-edit__overlay',
      triggerHover: 'i4-component-edit__trigger_hover',
      triggerBar: 'i4-component-edit__trigger_bar',
      toolbar: 'i4-component-edit__toolbar',
      toolbarPluginName: 'i4-component-edit__toolbar--plugin-name',
      toolbarItem: 'i4-component-edit__toolbar-item'
    };

    this.modifiers = {
      overlayBar: 'i4-component-edit__overlay--bar',
      active: 'i4-component-edit--active',
      open: 'i4-component-edit--open'
    };

    this.triggers = {
      toolbarHide: 'i4-toolbar:hide',
      toolbarRendered: 'i4-toolbar:rendered'
    };
  }

  init() {
    this.dataPluginName = this.$element.data(this.data.pluginName);
    this.dataButtons = this.$element.data(this.data.buttons);

    // console.log(this);

    this.$body = $(this.selectors.body);
    this.$body.on(this.triggers.toolbarHide, this.hide.bind(this));

    this.render();
    this.registerDocumentListener();
  }

  render() {
    if (this.$element.css('position') !== 'relative') {
      this.$element.css('position', 'relative');
    }

    this.$container = $('<div></div>').addClass(this.classNames.container);
    this.$element.prepend(this.$container);

    this.$overlay = $('<div></div>').addClass(this.classNames.overlay);

    // render bar or hover area as the trigger for opening the element's edit dialog
    if (this.$element.data(this.data.editMode) && this.$element.data(this.data.editMode) === 'bar') {
      this.renderTriggerContainer(this.classNames.triggerBar);

      this.$overlay.addClass(this.modifiers.overlayBar);
    } else {
      this.renderTriggerContainer(this.classNames.triggerHover);
    }

    this.renewHeight();
  }

  renderTriggerContainer(containerClass) {
    const $hover = $('<div></div>')
      .addClass(containerClass)
      .on('mouseover', (function () {
        if (!this.clicked) {
          this.$body.trigger(this.triggers.toolbarHide);
          this.$container.addClass(this.modifiers.active);
        }
      }).bind(this))
      .on('mouseout', (function () {
        if (!this.clicked) {
          this.hide();
        }
      }).bind(this))
      .on('click', (function (event) {
        this.clicked = true;
        this.$container.addClass(this.modifiers.open);
        this.renderToolbar(event);
      }).bind(this));

    this.$container.prepend(this.$overlay);
    this.$container.prepend($hover);
  }

  hide() {
    this.$container.removeClass(this.modifiers.active);
    this.$container.removeClass(this.modifiers.open);

    this.clicked = false;
  }

  renderToolbar(event) {
    if (!this.toolbarRendered) {

      this.$toolbar = $('<div></div>').addClass(this.classNames.toolbar);
      this.$toolbarPluginName = $('<div>' + this.dataPluginName + '</div>').addClass(this.classNames.toolbarPluginName);
      this.$toolbar.append(this.$toolbarPluginName);
      this.$container.append(this.$toolbar);

      $(this.dataButtons).each((i, item) => {
        var $button = this.getButton(item);
        this.$toolbar.append($button);
      });

      const sortInstance = i4_Sort.get(this.$element);
      if (sortInstance) {
        sortInstance.run();
      }

      this.$element.trigger(this.triggers.toolbarRendered);

      this.toolbarRendered = true;
    }

    this.$toolbar.css({
      'marginTop': event.pageY - this.$element.offset().top + 'px'
    }).show();
  }

  getButton(button) {
    const result = $('<span></span>').addClass(this.classNames.toolbarItem);

    switch (button.popup_parameter.call) {

      case 'edit':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-pencil', i4_Translation.get().edit))
        ).on('click', (function (event) {
          i4_Document_listener.set_click_position({
            top: event.pageY,
            left: event.pageX
          });

          this.showPopup(button);
          this.hide();
        }).bind(this));
        break;

      case 'settings':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-settings', i4_Translation.get().edit))
        ).on('click', (function (event) {
          i4_Document_listener.set_click_position({
            top: event.pageY,
            left: event.pageX
          });

          this.showPopup(button);
          this.hide();
        }).bind(this));
        break;

      case 'new_below':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-new-below', i4_Translation.get().new_below))
        ).on('click', (function (event) {
          i4_Document_listener.set_click_position({
            top: event.pageY,
            left: event.pageX
          });

          this.showPopup(button);
          this.hide();
        }).bind(this));
        break;

      case 'move':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-move', i4_Translation.get().move))
        ).
        addClass(button.options.class_name).
        css('cursor', 'move');
        break;

      case 'copy':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-copy-clipboard', i4_Translation.get().copy))
        ).on('click', (function (event) {
          i4_Ajax.factory().
          set_parameter('js=Aggregator&call=copy&element_id=' + button.popup_parameter.element_id).
          set_option({
            on_complete: function () {
              i4_Message.show(i4_Translation.get().copied_to_clipboard);
            }
          }).
          run();
        }).bind(this));
        break;

      case 'follow':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-link', i4_Translation.get().follow))
        ).on('click', (function (event) {
          window.document.location = button.popup_parameter.url;
        }).bind(this));
        break;

      case 'delete':
        result.append(
            $(this.createSVG('#svg-sprite-system-icon-delete', i4_Translation.get().delete))
          )
          .on('click', (function (event) {
            i4_Document_listener.set_click_position({
              top: event.pageY,
              left: event.pageX
            });

            this.showPopup(button);
            this.hide();
          }).bind(this));
        break;

      case 'disconnect':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-disconnect', i4_Translation.get().disconnect))
        ).on('click', (function (event) {
          i4_Document_listener.set_click_position({
            top: event.pageY,
            left: event.pageX
          });

          this.showPopup(button);
          this.hide();
        }).bind(this));
        break;

        /* slideshow buttons */
      case 'grid':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-grid', i4_Translation.get().grid))
        ).
        addClass(button.options.class_name);

        break;

      case 'play':
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-play', i4_Translation.get().play))
        ).
        addClass(button.options.class_name);

        break;

      case 'article_reject':
        // Kyburz: Hauszeitung reject article
        result.append(
          $(this.createSVG('#svg-sprite-plugin-hauszeitung-article-reject', i4_Translation.get().reject))
        ).on('click', (function (event) {
          i4_Document_listener.set_click_position({
            top: event.pageY,
            left: event.pageX
          });
          this.showPopup(button);
          this.hide();
        }).bind(this));
        break;

      case 'article_activate':
        // Kyburz: Hauszeitung activate article
        result.append(
          $(this.createSVG('#svg-sprite-plugin-hauszeitung-article-activate', i4_Translation.get().activate))
        ).on('click', ((event) => {
          i4_Ajax.factory().
          set_parameter('js=Hauszeitung&call=article_activate&article_id=' + button.popup_parameter.article_id).
          set_option({
            on_complete: () => {
              this.showPopup(button);
              this.hide();
            }
          }).
          run();
        }).bind(this));
        break;

      case 'article_duplicate':
        // Kyburz: Hauszeitung duplicate article
        result.append(
          $(this.createSVG('#svg-sprite-system-icon-duplicate', i4_Translation.get().duplicate))
        ).on('click', (function (event) {
          i4_Document_listener.set_click_position({
            top: event.pageY,
            left: event.pageX
          });
          this.showPopup(button);
          this.hide();
        }).bind(this));
        break;

      default:
    }

    return result;
  }

  showPopup(button) {
    // console.log(button.popup_parameter);

    i4_Popup.add().set_option({
      ajax_param: JSON.parse(JSON.stringify(button.popup_parameter)),
      position: 'cursor',
      loader: true
    }).run();
  }

  renewHeight() {
    const sublist = this.$element.find('> .c-navigation__sublist');
    if (sublist.length && sublist.css('position') != 'absolute') {
      const link = this.$element.find('a:first')[0];

      const height = $(link).outerHeight(true);

      this.$container.css({
        'height': height + 'px'
      });
    }
  }

  registerDocumentListener() {
    i4_Document_listener.add('click', {
      exclude: ['.i4-component-edit *'],
      callback: (function () {
        this.hide();
      }).bind(this)
    });
    i4_Document_listener.run();
  }

  createSVG(id, title) {
    // Create »svg« and »use« element with JavaScript (https://florianbrinkmann.com/en/svg-use-element-javascript-4513/)
    const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const titleElem = document.createElementNS('http://www.w3.org/2000/svg', 'title');
    const useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');

    titleElem.innerHTML = title;
    useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', id);
    svgElem.appendChild(titleElem);
    svgElem.appendChild(useElem);

    return svgElem;
  }
}

i4_Decorator_loader.registerClass('i4_Edit_toolbar', i4_Edit_toolbar);

/**
 * @todo: create a global page json for values like this. may be combine with i4_Ajax.set_ajax_file()
 */
var i4_Edit_buttons = {
  buttons: {},

  add: function (buttons) {
    this.buttons = buttons;
    return this;
  }
};
